import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useRef, useEffect } from 'react';
/*
 * A React hook to measure the width and height of an HTML element and
 * keep the measurements updated when the element's size changes.
 */
var useElementSize = function useElementSize() {
  var _useState = useState({
      width: 0,
      height: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var elementRef = useRef(null);
  useEffect(function () {
    if (!elementRef.current) return;

    // Callback to update the size state
    var updateSize = function updateSize() {
      if (elementRef.current) {
        setSize({
          width: elementRef.current.offsetWidth,
          height: elementRef.current.offsetHeight
        });
      }
    };

    // Create a ResizeObserver to watch the element
    var resizeObserver = new ResizeObserver(updateSize);
    resizeObserver.observe(elementRef.current);

    // Set initial size
    updateSize();

    // Cleanup
    return function () {
      return resizeObserver.disconnect();
    };
  }, []);
  return {
    width: size.width,
    height: size.height,
    elementRef: elementRef
  };
};
export default useElementSize;